import React from 'react'
import { Toggle, Button, Input } from '@driftt/tide-core-legacy'
import { Map } from 'immutable'
import IconSVG from 'svg-inline-react'

const MeetingPrepEducationSVG = require('!svg-inline?!images/assistant-config/meeting-prep.svg')
const FollowUpEducationSVG = require('!svg-inline?!images/assistant-config/follow-up.svg')

import DelayTime from './DelayTime'
import EmailTemplateModal from './EmailTemplateModal'
import './style.styl'

const CONSTANTS = {
  MEETING_PREP: {
    toggleText: 'Get an email to help prepare for meetings',
    delayTimeText: '',
    templateText: '',
    educationSVG: MeetingPrepEducationSVG,
    educationCopy: [
      "The Drift Assistant will handle all of the required research before every meeting.",
      "Includes company tech stack, context from previous conversations, and notes on recent website activity."
    ]
  },
  MEETING_CANCELLED: {
    toggleText: 'Get an email reminder to follow up',
    delayTimeTextFirstHalf: 'Send me a reminder to follow up',
    delayTimeTextSecondHalf: 'after a demo is rescheduled or cancelled',
    templateText: 'Customize the follow up email template:',
    educationSVG: FollowUpEducationSVG,
    educationCopy: [
      "We'll check all Salesforce activity, email, meeting history, and chat before reminding you to follow up.",
      "Send a follow-up email in one click."
    ],
  },
  DEMO_FOLLOW_UP: {
    toggleText: 'Get an email reminder to send next steps',
    delayTimeTextFirstHalf: 'Send me a reminder to send a next steps email',
    delayTimeTextSecondHalf: 'after a demo is held',
    templateText: 'Customize the next steps email template:',
    educationSVG: FollowUpEducationSVG,
    educationCopy: [
      "It's easy to forget to send a note with next steps with everything going on in the sales process.",
      "The Drift Assistant will make sure none of your potential customers fall through the cracks by sending you an email."
    ]
  }
}

const MeetingTaskConfig = ({
  hasTemplate,
  modalOpen,
  toggleModal,
  settingName,
  assistantAgentSettings,
  editingAssistantAgentSettings,
  onSave,
  onCancel,
  actions: {
    onUpdate,
    onWarmLeadUpdate,
    onWarmLeadUpdateTemplate
  }
}) => {
  const settingForTask = editingAssistantAgentSettings.get(settingName, Map())
  const agentMeetingConfirmationTaskSettings = editingAssistantAgentSettings.get('MEETING_CONFIRMATION_AGENT', Map())

  const isWarmLeadTask = settingName === 'MEETING_CANCELLED'
  const updateFunc = isWarmLeadTask ? onWarmLeadUpdate : onUpdate

  let hasChanges = false
  if (isWarmLeadTask) {
    hasChanges = !assistantAgentSettings.get('MEETING_CANCELLED').equals(editingAssistantAgentSettings.get('MEETING_CANCELLED'))
    || !assistantAgentSettings.get('MEETING_RESCHEDULED').equals(editingAssistantAgentSettings.get('MEETING_RESCHEDULED'))
  }
  if (settingName === 'MEETING_PREP') {
    hasChanges = !assistantAgentSettings.get('MEETING_PREP').equals(editingAssistantAgentSettings.get('MEETING_PREP'))
    || !assistantAgentSettings.get('MEETING_CONFIRMATION_AGENT').equals(editingAssistantAgentSettings.get('MEETING_CONFIRMATION_AGENT'))
  }
  if (settingName === 'DEMO_FOLLOW_UP') {
    hasChanges = !assistantAgentSettings.get(settingName).equals(editingAssistantAgentSettings.get(settingName))
  }


  return <div className="assistant-task-config">
    <div className="left">
      <div className="assistant-task-config-toggle">
        <h3>{CONSTANTS[settingName].toggleText}</h3>
        {settingName !== 'MEETING_PREP' && (
          <Toggle
            checked={settingForTask.get('on', false)}
            onChange={(e) => {
              const newSettings = settingForTask.set('on', !settingForTask.get('on'))
              updateFunc({ settingName, newSettings })
            }}
          />
        )}
      </div>
      <div className="assistant-task-config-body">
        {settingName !== 'MEETING_PREP' ? (
          <div className="assistant-task-config-delay-time">
            <div className="assistant-task-config-body-content">
              {CONSTANTS[settingName].delayTimeTextFirstHalf}
              <DelayTime
                value={agentMeetingConfirmationTaskSettings.get('delayTime')}
                onUpdate={(value) => {
                  const newSettings = agentMeetingConfirmationTaskSettings.set('delayTime', value)
                  updateFunc({ settingName: 'MEETING_CONFIRMATION_AGENT', newSettings })
                }}
              />
              {CONSTANTS[settingName].delayTimeTextSecondHalf}
            </div>
          </div>
        ) : (
          <div>
            <div className="assistant-task-config-delay-time">
              <Input
                type="checkbox"
                className="assistant-task-config-checkbox"
                checked={agentMeetingConfirmationTaskSettings.get('on', false)}
                onChange={(e) => {
                  const newSettings = agentMeetingConfirmationTaskSettings.set('on', !agentMeetingConfirmationTaskSettings.get('on'))
                  updateFunc({ settingName: 'MEETING_CONFIRMATION_AGENT', newSettings })
                }}
                />              
              <div className="assistant-task-config-body-content assistant-config-with-checkbox">
                Send me a meeting confirmation email
                <DelayTime
                  value={agentMeetingConfirmationTaskSettings.get('delayTime')}
                  onUpdate={(value) => {
                    const newSettings = agentMeetingConfirmationTaskSettings.set('delayTime', value)
                    updateFunc({ settingName: 'MEETING_CONFIRMATION_AGENT', newSettings })
                  }}
                />
                after a meeting is booked
              </div>
            </div>
            <div className="assistant-task-config-delay-time">
            <Input
                type="checkbox"
                className="assistant-task-config-checkbox"
                checked={settingForTask.get('on', false)}
                onChange={(e) => {
                  const newSettings = settingForTask.set('on', !settingForTask.get('on'))
                  updateFunc({ settingName, newSettings })
                }}
                />
              <div className="assistant-task-config-body-content assistant-config-with-checkbox">
                Send me a meeting preparation email
                <DelayTime
                  value={settingForTask.get('delayTime')}
                  onUpdate={(value) => {
                    const newSettings = settingForTask.set('delayTime', value)
                    updateFunc({ settingName, newSettings })
                  }}
                />
                before a meeting is held
              </div>
            </div>
          </div>
        )}
        {(hasTemplate) &&
          <div className="assistant-task-config-template">
            <h3 className="assistant-task-config-body-h3">{CONSTANTS[settingName].templateText}</h3>
            <Button
                type="subtle"
                size="medium"
                onClick={toggleModal}
              >
                Edit Template
            </Button>
            {modalOpen && <EmailTemplateModal
              settingName={settingName}
              editingAssistantAgentSettings={editingAssistantAgentSettings}
              onSave={(state) => {
                if (isWarmLeadTask) {
                  onWarmLeadUpdateTemplate(state)
                } else {
                  const newSettings = settingForTask
                    .set('emailSubject', state[settingName].get('emailSubject'))
                    .set('emailBody', state[settingName].get('emailBody'))
                  onUpdate({ settingName, newSettings })
                }
                toggleModal()
              }}
              onCancel={toggleModal}
            />}
          </div>
        }
        {hasChanges && <div className="assistant-task-config-save-buttons">
          <Button
            type="primary"
            size="medium"
            onClick={() => onSave()}
          >
            Save
              </Button>
          <Button
            type="tertiary"
            onClick={onCancel}
          >
            Cancel
              </Button>
        </div>}
      </div>
    </div>
    <div className="right">
      <div className="assistant-task-config-education-icon"><IconSVG src={CONSTANTS[settingName].educationSVG} /></div>
        <div className="assistant-task-config-education-text">
          <b>How it works:</b>
          {
            _.map(CONSTANTS[settingName].educationCopy, copy => <span className="education-text"><div className="bullet">•</div>{copy}</span>)
          }
        </div>
    </div>
  </div>
}

export default MeetingTaskConfig



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfig/MeetingTaskConfig/component.js